export default "__VITE_ASSET__WAKu3OuR__"